import useSWR from 'swr';
import LayerSwapApiClient from '../lib/apiClients/layerSwapApiClient';
import { useGaslessAuthorizationStore } from '../stores/swapTransactionStore';
import { recordSwapExecution } from '../lib/swapExecution';
import { gaslessAuthorizationKey, isGaslessAuthorizationForWorkflow } from '../helpers/gasless';
const apiClient = new LayerSwapApiClient();
const POLL_INTERVAL_MS = 4000;
const TERMINAL_STATUSES = new Set([
    'completed',
    'expired',
    'insufficient',
    'rejected',
]);
export function isTerminalGaslessStatus(status) {
    return !!status && TERMINAL_STATUSES.has(status);
}
// Share the fetched response with execution and processing; never persist its outcome.
export function useGaslessAuthorizationStatus(swapId, depositActions) {
    const authorization = useGaslessAuthorizationStore(state => swapId ? state.authorizations[swapId] : undefined);
    const active = !!swapId && isGaslessAuthorizationForWorkflow(authorization, depositActions);
    const { data } = useSWR(active ? gaslessAuthorizationKey(swapId) : null, () => apiClient.GetGaslessAuthorizationAsync(swapId), {
        onSuccess: response => {
            if (swapId && !response.error)
                recordSwapExecution(swapId, { depositActions, gaslessAuthorization: response.data });
        },
        refreshInterval: response => isTerminalGaslessStatus(response?.data?.status) ? 0 : POLL_INTERVAL_MS,
        errorRetryCount: 5,
        revalidateOnFocus: false,
        revalidateOnMount: true,
        keepPreviousData: false,
    });
    return active ? data?.data : undefined;
}
